import { render } from "./HomeSliderComponent.vue?vue&type=template&id=4e04fd10&scoped=true"
import script from "./HomeSliderComponent.vue?vue&type=script&lang=js"
export * from "./HomeSliderComponent.vue?vue&type=script&lang=js"

import "./HomeSliderComponent.vue?vue&type=style&index=0&id=4e04fd10&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e04fd10"]])

export default __exports__